/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_End_TimeInputs */

const en_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include End Time`)
};

const fr_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure l'heure de fin`)
};

const de_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endzeit einschließen`)
};

const it_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi ora di fine`)
};

const ru_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Укажите время окончания`)
};

const es_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir hora de finalización`)
};

const zh_cn2_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包括结束时间`)
};

const ja_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了時間を含める`)
};

const hi_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति समय शामिल करें`)
};

const pt_pt2_transcript_export_include_end_time = /** @type {(inputs: Transcript_Export_Include_End_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir horário de término`)
};

/**
* | output |
* | --- |
* | "Include End Time" |
*
* @param {Transcript_Export_Include_End_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_end_time = /** @type {((inputs?: Transcript_Export_Include_End_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_End_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_include_end_time(inputs)
	if (locale === "de") return de_transcript_export_include_end_time(inputs)
	if (locale === "it") return it_transcript_export_include_end_time(inputs)
	if (locale === "ru") return ru_transcript_export_include_end_time(inputs)
	if (locale === "es") return es_transcript_export_include_end_time(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_include_end_time(inputs)
	if (locale === "ja") return ja_transcript_export_include_end_time(inputs)
	if (locale === "hi") return hi_transcript_export_include_end_time(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_include_end_time(inputs)
	return en_transcript_export_include_end_time(inputs)
});